import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {TableauReportsService} from "../../services/tableau-reports/tableau-reports.service";
import {forkJoin} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {AlertService} from "../../services/alert/alert.service";
import {TABLEAU_DASHBOARDS} from "../../shared/common-components/AppConstants";
import {LoadingService} from "../../services/loading/loading.service";

@Component({
    selector: 'app-hhg-tableau-dashboards',
    imports: [],
    templateUrl: './hhg-tableau-dashboards.component.html',
    styleUrl: './hhg-tableau-dashboards.component.css',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HhgTableauDashboardsComponent implements OnInit {
  dashboardName;
  accessID;
  viz: any

  constructor(private tableauReportsService: TableauReportsService, private route: ActivatedRoute,
              private alertService: AlertService, private loader: LoadingService
  ) { }
  ngOnInit() {
    this.loader.show();
    this.route.paramMap.subscribe(params => {
      if (params.has('dashboardName')) {
        this.dashboardName = params.get('dashboardName');
        this.tableauReportsService.getTableauReports(this.dashboardName, 'HHG').subscribe((response1: string[]) => {
          this.initializeViz(response1);
          this.loader.hide();
        }, error => {
          this.loader.hide();
          this.alertService.error('Error while fetching the dashboard data.');
        })
      }
    });
  }

  initializeViz(url: string[]) {
    document.getElementById("tableauViz").shadowRoot.getElementById("tableauViz").removeAttribute("sandbox");
    this.viz = document.getElementById("tableauViz");
    this.viz.width = 1000;
    this.viz.height = 827;
    this.viz.hideTabs = true;
    this.viz.hideToolbar = false;
    const onFirstInteractive = () => {
      // document.getElementById("tableauViz").shadowRoot.getElementById("tableauViz").setAttribute("sandbox", "allow-same-origin allow-scripts allow-downloads");
      document.getElementById("tableauViz").shadowRoot.getElementById("tableauViz").setAttribute("sandbox", "allow-downloads");
    };

    this.viz.addEventListener("firstinteractive", onFirstInteractive);
    this.viz.src = url[1];
    this.viz.token = url[0];
    this.accessID = url[2];
    document.getElementById("accessIdParm").setAttribute("value",this.accessID);
  }

  getDashboardTitle(name: string): string {
    return TABLEAU_DASHBOARDS[name];
  }
}

